<!-- B100系Steps項目 -->
<div class="container">
    <div class="progress-container">
      <div
        class="progress"
        id="progress"
        [ngStyle]="{ width: progressWidth }"
      ></div>
      <div class="circle" [ngClass]="{ active: isActiveStep(1) }">
        <span class="first-step"></span>
        <span
          class="first-step-text"
          [ngClass]="{ 'active-text': isActiveText(1) }"
          >{{stepsItems[0].label}}</span
        >
      </div>
      <div class="circle" [ngClass]="{ active: isActiveStep(2) }">
        <span class="second-step"></span>
        <span
          class="second-step-text"
          [ngClass]="{ 'active-text': isActiveText(2) }"
          >{{stepsItems[1].label}}</span
        >
      </div>
      <div class="circle" [ngClass]="{ active: isActiveStep(3) }">
        <span class="third-step"></span>
        <span
          class="third-step-text"
          [ngClass]="{ 'active-text': isActiveText(3) }"
          >{{stepsItems[2].label}}</span
        >
      </div>
    </div>
  </div>
  
